var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_8092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55991 4.64062H16.1175C16.4268 4.64062 16.6774 4.3888 16.6774 4.07812V2.67188C16.6774 2.3612 16.4268 2.10938 16.1175 2.10938H1.55991C1.25066 2.10938 1 2.3612 1 2.67188V4.07812C1 4.3888 1.25066 4.64062 1.55991 4.64062ZM1.55991 10.2656H16.1175C16.4268 10.2656 16.6774 10.0138 16.6774 9.70312V8.29688C16.6774 7.9862 16.4268 7.73438 16.1175 7.73438H1.55991C1.25066 7.73438 1 7.9862 1 8.29688V9.70312C1 10.0138 1.25066 10.2656 1.55991 10.2656ZM1.55991 15.8906H16.1175C16.4268 15.8906 16.6774 15.6388 16.6774 15.3281V13.9219C16.6774 13.6112 16.4268 13.3594 16.1175 13.3594H1.55991C1.25066 13.3594 1 13.6112 1 13.9219V15.3281C1 15.6388 1.25066 15.8906 1.55991 15.8906Z",
    fill: "#B1BAD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_8092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6774,
    height: 18,
    fill: "white",
    transform: "translate(1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.3659240fae04b413ea485f7f7153089b.svg";
export { ForwardRef as ReactComponent };